import { formatDate } from '@btime/helpers'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { useForm } from './_load/FormLoader'
import { useFormReply } from './_load/FormReplyLoader'
import { useNavigationWithModalCloser } from '../../../utils/contexts/NavigationContext'
import Center from '../../../packages/kiti/components/helpers/Center'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import IconButton from '../../../components/actions/IconButton'
import Link from '../../../packages/kiti/components/actions/Link'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Text, { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'

const ModalHeader = ({ number, goToPrev, goToNext }) => {
  const { repliesCount } = useForm()
  const formReply = useFormReply() || {}
  const navigate = useNavigationWithModalCloser()

  const counter = `${number}/${repliesCount}`
  let replyNumber = false
  let title = `Resposta #${number}`
  let subtitle = formatDate('DD/MM/YYYY HH:mm', formReply.insertedAt)
  if (!!formReply.place) {
    replyNumber = title
    title = formReply.place.name
    subtitle = formReply.place.resume + ' | ' + subtitle
  }

  return (
    <Grid align="center">
      <Col flex={1}>
        {replyNumber && <SmallText size="xxsmall">{replyNumber}</SmallText>}
        <Title size="h3" color="dark2" noMargin>
          {title}
        </Title>
        <SmallText>{subtitle}</SmallText>
      </Col>
      <Link block onClick={goToPrev}>
        <Center>
          <Icon name="BsArrowLeftShort" size="1.6rem" />
        </Center>
      </Link>
      <Text bold>{counter}</Text>
      <Link block onClick={goToNext}>
        <Center>
          <Icon name="BsArrowRightShort" size="1.6rem" />
        </Center>
      </Link>

      <Separator vertical weight={4} />

      <Col>
        <IconButton
          icon="BsFileRichtext"
          onClick={() => navigate(`/forms/${formReply.formId}/pdf/${number}`)}
          transparent
          label="PDF"
        />
      </Col>
    </Grid>
  )
}

export default ModalHeader
